import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SauthTokenStore {
  private token: string | null = null;

  set(token: string): void {
    this.token = token;
  }

  get(): string | null {
    return this.token;
  }
}
